module.exports = __webpack_public_path__ + "static/media/logo-blue.68cb037a.svg";